
import {useState,useEffect} from 'react'
import DashboardMenu from './DashboardMenu'
// import { GetTodayLeadReminderService, getInsentiveTargetAchieved, getTargetAchieved } from '../../services/LeadServices';
import { useNavigate } from 'react-router-dom';
import { IoHandLeftOutline } from "react-icons/io5";
import { TbCloudDataConnection } from "react-icons/tb";
import { BiSupport } from "react-icons/bi";
import { MdOutlineSupervisedUserCircle } from "react-icons/md";
import { MdOutlineEventRepeat } from "react-icons/md";
import { RiNotification2Line } from "react-icons/ri";
import { PiCoinVerticalFill } from "react-icons/pi";
import { GetDashboardService, GetFilterStandardDashboardService } from '../../services/DashboardServices';
import { useDispatch, useSelector } from 'react-redux';
import ReactApexChart from 'react-apexcharts';
import { disconnectSocket, getSocket } from '../socket';
import { NotificationCountAction } from '../../redux/actions/authAction';
import { MdOutlineCallToAction } from "react-icons/md";
import { CiMobile3 } from "react-icons/ci";
import { SiGoogleclassroom } from "react-icons/si";
import { MdOutlineGroupWork } from "react-icons/md";
import { TbMoneybag } from "react-icons/tb";
import { PiMoney } from "react-icons/pi";
import TeacherPerformancePanel from '../teacher_feedback/components/TeacherPerformancePanel';

function Dashboard() {

  // clients/list
  const roles = useSelector(state=>state.Auth.roles)
  const user = useSelector(state=>state.Auth)
  const dispatch = useDispatch()

  console.log("user",user)

  const [menu,setmenu] = useState('Today')
  const [dashboardMode, setdashboardMode] = useState('Performance') // 'Default' | 'Performance' — the parent-feedback performance view for this employee/teacher; opens on Performance by default
  const [loader,setloader] = useState(true)

  const navigator = useNavigate()
  const [data,setdata] = useState({
    today_client:0,
    today_client_subscribed:0,
    total_client:0,
    subscribed_client:0
  })
  
  useEffect(()=>{
    getdata()
  },[])


  async function getdata() {
    const response = await GetDashboardService()
    const response1 = await GetFilterStandardDashboardService()

    let d = response?.data?.data
    let d1 = response1?.data?.data
    let series1 = [
        {
          name: 'count',
          data: [
            d?.clients_analytics?.clientsThisMonth,
            d?.clients_analytics?.clientsLast15Days,
            d?.clients_analytics?.clientsThisWeek,
            d?.clients_analytics?.clientsToday
          ]
        }
      ]
    dispatch(NotificationCountAction(d?.notification))
    setchartOptions1({...chartOptions1,series:series1})  

    let series2 = [
       {
          name: 'count',
          data: [
            d1?.find((f)=>f?.standard === 1)?.matched_count,
            d1?.find((f)=>f?.standard === 2)?.matched_count,
            d1?.find((f)=>f?.standard === 3)?.matched_count,
            d1?.find((f)=>f?.standard === 4)?.matched_count,
            d1?.find((f)=>f?.standard === 5)?.matched_count,
            d1?.find((f)=>f?.standard === 6)?.matched_count,
            d1?.find((f)=>f?.standard === 7)?.matched_count,
            d1?.find((f)=>f?.standard === 8)?.matched_count,
            d1?.find((f)=>f?.standard === 9)?.matched_count,
            d1?.find((f)=>f?.standard === 10)?.matched_count,
            d1?.find((f)=>f?.standard === 11)?.matched_count,
            d1?.find((f)=>f?.standard === 12)?.matched_count,
          ]
        }
    ]

    setchartOptions2({...chartOptions2,series:series2})
    setdata(response?.data?.data)
    setloader(false)
  }
 



  let rupeeIndian = Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  });


  function openPage(type){


     if(type === 1){
       roles.includes('admin') ? navigator('/dashboard/our_clients?type=All Data') : navigator('/clients/list?type=All Data')
     }

     if(type === 2){
       roles.includes('admin') ? navigator('/dashboard/our_clients?type=FollowUp') : navigator('/clients/list?type=FollowUp')
     }

     if(type === 3){
       roles.includes('admin') ? navigator('/dashboard/our_clients?type=Subscribed') : navigator('/clients/list?type=Subscribed')
     }

      if(type === 4){
       roles.includes('admin') ? navigator('/dashboard/our_clients?type=FollowUp') : navigator('/clients/list?type=FollowUp')
     }

  }

  const chartOptions = {
    plotOptions: {
      color: ['#000', '#000'],
      size: '100%',
      radialBar: {
        inverseOrder: false,
        startAngle: 0,
        endAngle: 360,
        offsetX: 0,
        offsetY: 0,
        hollow: {
          margin: 5,
          size: '50%',
          color: '#f2f2f2',
          image: undefined,
          imageWidth: 150,
          imageHeight: 150,
          imageOffsetX: 0,
          imageOffsetY: 0,
          imageClipped: true,
          position: 'front',

        },
        track: {
          show: true,
          startAngle: undefined,
          endAngle: undefined,
          background: '#f2f2f2',
          strokeWidth: '50%',
          opacity: 1,
          margin: 5,
          dropShadow: {
            enabled: false,
            top: 0,
            left: 0,
            opacity: 1
          }
        },
        dataLabels: {
          show: true,
          name: {
            show: true,
            fontSize: '12px',
            fontFamily: undefined,
            fontWeight: 400,
            color: undefined,
            color: '#000',
          },
          value: {
            show: true,
            fontSize: '14px',
            fontFamily: undefined,
            fontWeight: 900,
            color: undefined,
            offsetY: 1,
            formatter: function (val) {
              return val + '%'
            }
          },

        },

      },
    },
    labels: ['Total Client','Subscribed Client'],
    fill: {
      colors: ['#2a297e','#de9f19'],
    },
    tooltip: {
    enabled: true,
    theme: 'light',
    custom: function({ series, seriesIndex, w }) {
      return `
        <div style="
          background-color: ${w.config.fill.colors[seriesIndex]};
          color: #fff;
          padding: 6px 10px;
          border-radius: 4px;
          font-weight: bold;
          font-size:10px
        ">
          ${w.config.labels[seriesIndex]}: ${series[seriesIndex]}%
        </div>`;
    }
   }
  }

  const [chartOptions1, setchartOptions1] = useState({
    series: [],

    chart: {
      toolbar: {
        show: false
      }
    },
    colors: ['#2a297e'],
    plotOptions: {

      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
        dataLabels: {
          position: 'top', // top, center, bottom
        },

      },
    },
    dataLabels: {
      enabled: false
    },
    grid: {
      show: true,
      borderColor: '#fafafa',
    },

    stroke: {
      // show: true,
      width: 1,

      curve: 'smooth',
      // colors: ['transparent']
    },
    xaxis: {
      categories: [ '1 Month','15 Days','1 Week','Today'],
    },
    yaxis: {
      title: {
        text: 'Count'
      }
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val
        }
      }
    },
    fill: ['#2a297e']
  })

  const [chartOptions2, setchartOptions2] = useState({
    series: [],

    chart: {
      toolbar: {
        show: false
      }
    },
    colors: ['#2a297e'],
    plotOptions: {

      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
        dataLabels: {
          position: 'top', // top, center, bottom
        },

      },
    },
    dataLabels: {
      enabled: false
    },
    grid: {
      show: true,
      borderColor: '#fafafa',
    },

    stroke: {
      // show: true,
      width: 1,

      curve: 'smooth',
      // colors: ['transparent']
    },
    xaxis: {
      categories: [ '1st ','2nd','3rd','4th','5th','6th','7th','8th','9th','10th','1st PUC','2nd PUC'],
    },
    yaxis: {
      title: {
        text: 'Count'
      }
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val
        }
      }
    },
    fill: ['#2a297e']
  })

  function formatToCurrency(amount){
   return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(parseInt(amount)).split('.')[0]
  }

  function toAmPm(time24) {
    const [hour, minute] = time24.split(':').map(Number);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12; // converts 0 -> 12, 13 -> 1, etc.
    return `${hour12}:${String(minute).padStart(2, '0')} ${ampm}`;
  }

  function getGreeting(name) {
  const now = new Date();
  const hour = now.getHours(); // 0–23 format

  let greeting = '';
  if (hour >= 5 && hour < 12) {
    greeting = 'Good Morning';
  } else if (hour >= 12 && hour < 17) {
    greeting = 'Good Afternoon';
  } else if (hour >= 17 && hour < 21) {
    greeting = 'Good Evening';
  } else {
    greeting = 'Good Night';
  }

  return `${greeting} ${name}, `;
}

 console.log("user?.logged_user_type",user?.logged_user_type)

  // Only offline teachers enrolled in the parent-feedback program get a
  // Performance tab — everyone else just sees their usual batch/counsellor cards.
  const teacherHasPerformance = user?.logged_user_type === 'Teacher' && user?.mode === 'offline' && user?.show_in_feedback !== false

  return (
    <div className='md:h-screen md:min-h-screen md:max-h-screen md:overflow-hidden'>

      <div className='md:flex'>
        <DashboardMenu />
        <div className='md:w-[100%] md:w-[86%] flex md:h-screen md:min-h-screen md:max-h-screen md:overflow-y-scroll relative'>
         {!loader &&
         <div className='w-[100%] px-4 pt-5 '> 


           {user?.logged_user_type === 'Employee' && <>
           <div className='bg-yellow-100 p-2 mb-4 text-[12px]'>
            <h6>Your Working ours Will be <span className='font-[700]'>{toAmPm(user?.working_hours?.start_time)} - {toAmPm(user?.working_hours?.end_time)}</span> </h6>
           </div></>} 

            <h6 className='mb-4 text-[15px] font-[800]'>{getGreeting(user?.name)}</h6> 

            {user?.logged_user_type === 'Teacher' && <>
            {/* Only offline teachers enrolled in the feedback program
                (show_in_feedback) get a Performance tab to switch to — for
                everyone else this just renders the batch/counsellor cards
                below as before, no toggle. */}
            {teacherHasPerformance && (
              <div className='flex rounded overflow-hidden border w-[200px] cursor-pointer text-[10px] mb-3'>
                <h6 onClick={()=>setdashboardMode('Default')} className={`${dashboardMode === 'Default' && 'bg-[#2a297e] text-white'} font-[800] p-2 w-[100px] text-center`}>Default</h6>
                <h6 onClick={()=>setdashboardMode('Performance')} className={`${dashboardMode === 'Performance' && 'bg-[#2a297e] text-white'} font-[800] p-2 w-[100px] text-center`}>Performance</h6>
              </div>
            )}

            {(!teacherHasPerformance || dashboardMode === 'Default') && (
            <div className='border p-1'>
            <div className='grid grid-cols-2 md:grid-cols-5 items-center justify-evenly '>
              {roles?.includes('Batch') &&
              <div className='border mx-2 mt-2 md:mb-0 border-slate-200 px-2 py-2 w-[96%]' onClick={()=>navigator('/batches_booking')}>
                <h6 className='text-[12px] text-slate-700 font-[600] flex items-center'><SiGoogleclassroom size={23} className='mr-2 bg-red-200 p-1 text-red-500' /> Batch Students </h6>
                <h6 className='text-[14px] mt-1'>{rupeeIndian?.format(JSON.stringify(data?.teacherBatches))?.split('.')[0].slice(1)}</h6>
              </div>}
              {roles?.includes('Counsellor') &&
              <div className='border mx-2 mt-2 md:mb-0 border-slate-200 px-2 py-2 w-[96%]' onClick={()=>navigator('/class_booking/list')}>
                <h6 className='text-[12px] text-slate-700 font-[600] flex items-center'><MdOutlineGroupWork size={23} className='mr-2 bg-yellow-200 p-1 text-yellow-500' /> Demo Class </h6>
                <h6 className='text-[14px] mt-1'>{rupeeIndian?.format(JSON.stringify(data?.teacherBatches))?.split('.')[0].slice(1)}</h6>
              </div>}
            </div>
            </div>
            )}

            {teacherHasPerformance && dashboardMode === 'Performance' && (
            <div className='mt-3'>
              <TeacherPerformancePanel />
            </div>
            )}
            </>}

            {user?.logged_user_type === 'Distributor' &&
            <div className='border p-1'>
              
            <div className='grid grid-cols-2 md:grid-cols-5 items-center justify-evenly '>
              <div className='border mx-2 mt-2 md:mb-0 border-slate-200 px-2 py-2 w-[96%]' onClick={()=>navigator('/digital_card/list')}>
                <h6 className='text-[12px] text-slate-700 font-[600] flex items-center'><SiGoogleclassroom size={23} className='mr-2 bg-red-200 p-1 text-red-500' /> Digital Card </h6>
                <h6 className='text-[14px] mt-1'>{rupeeIndian?.format(JSON.stringify(data?.digital_card))?.split('.')[0].slice(1)}</h6>
              </div>

              <div className='border mx-2 mt-2 md:mb-0 border-slate-200 px-2 py-2 w-[96%]'>
                <h6 className='text-[12px] text-slate-700 font-[600] flex items-center'><TbMoneybag size={23} className='mr-2 bg-orange-200 p-1 text-orange-500' /> Revenue Made </h6>
                <h6 className='text-[14px] mt-1'>{rupeeIndian?.format(JSON.stringify(user?.amount))?.split('.')[0].slice(1)}</h6>
              </div>

               <div className='border mx-2 mt-2 md:mb-0 border-slate-200 px-2 py-2 w-[96%]'>
                <h6 className='text-[12px] text-slate-700 font-[600] flex items-center'><PiMoney size={23} className='mr-2 bg-cyan-200 p-1 text-cyan-500' /> Total Subscription </h6>
                <h6 className='text-[14px] mt-1'>{rupeeIndian?.format(JSON.stringify(user?.total_subscription_count))?.split('.')[0].slice(1)}</h6>
              </div>
            </div>

            </div>
            }



            {user?.logged_user_type === 'Employee' && <>
            <div className='flex rounded overflow-hidden border w-[200px] cursor-pointer text-[10px] mb-3'>
              <h6 onClick={()=>setdashboardMode('Default')} className={`${dashboardMode === 'Default' && 'bg-[#2a297e] text-white'} font-[800] p-2 w-[100px] text-center`}>Default</h6>
              <h6 onClick={()=>setdashboardMode('Performance')} className={`${dashboardMode === 'Performance' && 'bg-[#2a297e] text-white'} font-[800] p-2 w-[100px] text-center`}>Performance</h6>
            </div>

            {dashboardMode === 'Performance' && <TeacherPerformancePanel />}

            {dashboardMode === 'Default' && <>
            <div className='border p-1 relative'>


                <div className='flex absolute right-36 top-[10px] rounded overflow-hidden border w-[100px] cursor-pointer  text-[11px]'>
                  <h6 onClick={()=>setmenu('Today')} className={`${menu === 'Today' && 'bg-[#de9f19]'} font-[800] p-1 w-[50px] text-center`}>Today</h6>
                  <h6 onClick={()=>setmenu('Overall')} className={`${menu === 'Overall' && 'bg-[#de9f19]'} font-[800] p-1 w-[50px] text-center`}>Overall</h6>
                </div>

                <div onClick={()=>navigator('/dashboard/notification')} className='relative mr-[27px]'>
                  <h6 className='absolute right-[70px] z-20 p-[4px] rounded-full bg-[#2a297e] text-white flex items-center text-center justify-center text-[8px]'>{user?.notification_count}</h6>
                  <RiNotification2Line  size={22} className='absolute right-20 top-[8px] cursor-pointer bg-gray-100 rounded p-[4px]'  />
                </div>
                <div className='bg-[#2a297e] p-1 min-w-[50px] absolute right-[25px] top-[10px]  rounded shadow text-white flex items-center'>
                  <PiCoinVerticalFill className='text-[#de9f19] animate-bounce' />
                  <h6 className='font-[700] text-[11px] ml-2'>{roles?.includes('wfh') ? formatToCurrency(data?.userWalletInfo) : data?.userWalletInfo}</h6>
                </div>
              
                {/* section 1  */}
                <h1 className='ml-2 my-2 font-[800] text-[13px]'>My Dashboard</h1>
                <div className='grid grid-cols-2 md:grid-cols-5 items-center justify-evenly '>
                       {menu === 'Overall' && <>
                        <div className='border mx-2 mt-2 md:mb-0 border-slate-200 px-2 py-2 w-[96%]' onClick={()=>openPage(1)}>
                          <h6 className='text-[12px] text-slate-700 font-[600] flex items-center'><MdOutlineSupervisedUserCircle size={23} className='mr-2 bg-blue-200 p-1 text-blue-500' /> Total Clients </h6>
                          <h6 className='text-[14px] mt-1'>{rupeeIndian?.format(JSON.stringify(data?.total_client))?.split('.')[0].slice(1)}</h6>
                        </div>
                        <div className='border mx-2 mt-2 md:mb-0 border-slate-200 px-2 py-2 w-[96%]' onClick={()=>openPage(2)}>
                          <h6 className='text-[12px] text-slate-700 font-[600] flex items-center'><MdOutlineEventRepeat size={23} className='mr-2 bg-orange-200 p-1 text-orange-500' /> Client Followup </h6>
                          <h6 className='text-[14px] mt-1'>{rupeeIndian?.format(JSON.stringify(data?.client_followup))?.split('.')[0].slice(1)}</h6>
                        </div>
                        <div className='border mx-2 mt-2 md:mb-0 border-slate-200 px-2 py-2 w-[96%]' onClick={()=>openPage(3)}>
                          <h6 className='text-[12px] text-slate-700 font-[600] flex items-center'><CiMobile3 size={23} className='mr-2 bg-cyan-100 p-1 text-cyan-800' /> App Installed Client </h6>
                          <h6 className='text-[14px] mt-1'>{rupeeIndian?.format(JSON.stringify(data?.app_installed_client))?.split('.')[0].slice(1)}</h6>
                        </div>
                        <div className='border mx-2 mt-2 md:mb-0 border-slate-200 px-2 py-2 w-[96%]' onClick={()=>openPage(3)}>
                          <h6 className='text-[12px] text-slate-700 font-[600] flex items-center'><TbCloudDataConnection size={23} className='mr-2 bg-green-200 p-1 text-green-500' /> Subscribed Client </h6>
                          <h6 className='text-[14px] mt-1'>{rupeeIndian?.format(JSON.stringify(data?.subscribed_client))?.split('.')[0].slice(1)}</h6>
                        </div>
                        <div className='border mx-2 mt-2 md:mb-0 border-slate-200 px-2 py-2 w-[96%]' onClick={()=>openPage(4)}>
                          <h6 className='text-[12px] text-slate-700 font-[600] flex items-center'><IoHandLeftOutline size={23} className='mr-2 bg-purple-200 p-1 text-purple-500' /> Interested Client </h6>
                          <h6 className='text-[14px] mt-1'>{rupeeIndian?.format(JSON.stringify(data?.intrested_client))?.split('.')[0].slice(1)}</h6>
                        </div>
                        {roles?.includes('admin') 
                          &&
                          <>
                            <div className='border mx-2 mt-2 md:mb-0 border-slate-200 px-2 py-2 w-[96%]' onClick={()=>navigator('/settings/onboard_list')}>
                              <h6 className='text-[12px] text-slate-700 font-[600] flex items-center'><BiSupport size={23} className='mr-2 bg-indigo-200 p-1 text-indigo-500' /> Sales Executive </h6>
                              <h6 className='text-[14px] mt-1'>{rupeeIndian?.format(JSON.stringify(data?.sales_executive))?.split('.')[0].slice(1)}</h6>
                            </div>

                          <div className='border mx-2 mt-2 md:mb-0 border-slate-200 px-2 py-2 w-[96%]' onClick={()=>navigator('/batches_booking')}>
                            <h6 className='text-[12px] text-slate-700 font-[600] flex items-center'><SiGoogleclassroom size={23} className='mr-2 bg-red-200 p-1 text-red-500' /> Batch Students </h6>
                            <h6 className='text-[14px] mt-1'>{rupeeIndian?.format(JSON.stringify(data?.teacherBatches))?.split('.')[0].slice(1)}</h6>
                          </div>
                          <div className='border mx-2 mt-2 md:mb-0 border-slate-200 px-2 py-2 w-[96%]' onClick={()=>navigator('/class_booking/list')}>
                            <h6 className='text-[12px] text-slate-700 font-[600] flex items-center'><MdOutlineGroupWork size={23} className='mr-2 bg-yellow-200 p-1 text-yellow-500' /> Demo Class </h6>
                            <h6 className='text-[14px] mt-1'>{rupeeIndian?.format(JSON.stringify(data?.teacherBatches))?.split('.')[0].slice(1)}</h6>
                          </div>
                          </>}
                        </>}

                        
                        {(menu === 'Today' || menu === 'Overall') &&
                        <>
                        <div className='border mx-2 mt-2 md:mb-0 border-slate-200 px-2 py-2 w-[96%]' onClick={()=>openPage(1)}>
                          <h6 className='text-[12px] text-slate-700 font-[600] flex items-center'><MdOutlineSupervisedUserCircle size={23} className='mr-2 bg-[#d1f5ff] p-1 text-[#5a93a3]' />{menu === 'Today' ? 'Today' : 'Total'} Client </h6>
                          <h6 className='text-[14px] mt-1'>{rupeeIndian?.format(JSON.stringify(data?.today_client))?.split('.')[0].slice(1)}</h6>
                        </div>


                        <div className='border mx-2 mt-2 md:mb-0 border-slate-200 px-2 py-2 w-[96%]' onClick={()=>openPage(3)}>
                          <h6 className='text-[12px] text-slate-700 font-[600] flex items-center'><TbCloudDataConnection size={23} className='mr-2 bg-[#ebd8ca] p-1 text-[#ad7a55]' /> {menu === 'Today' ? 'Today' : 'Total'} Subscribed </h6>
                          <h6 className='text-[14px] mt-1'>{rupeeIndian?.format(JSON.stringify(data?.today_client_subscribed))?.split('.')[0].slice(1)}</h6>
                        </div>

                         <div className='border mx-2 mt-2 md:mb-0 border-slate-200 px-2 py-2 w-[96%]' >
                          <h6 className='text-[12px] text-slate-700 font-[600] flex items-center'><MdOutlineCallToAction size={23} className='mr-2 bg-[#ffe6f9] p-1 text-[#7a2866]' /> {menu === 'Today' ? 'Today' : 'Total'} Client Call </h6>
                          <h6 className='text-[14px] mt-1'>{rupeeIndian?.format(JSON.stringify(data?.today_client_call))?.split('.')[0].slice(1)}</h6>
                        </div>
                        </>}
                </div>


            </div> 

            {menu == 'Today' &&
            <div className='mt-2 md:flex '>
              <div className='border md:w-[35%] mr-2 md:h-[230px]'>
                  <div className='mt-2 px-2'>
                    <h1 className='font-bold pl-2 text-[14px]'>Analytics / <span className='text-[12px] text-gray-400 font-[500]'> Today Client v/s Subscribed Client</span> </h1>
                    <ReactApexChart width={370} options={chartOptions} size={'10'} series={[data?.today_client,data?.today_client_subscribed]} type="pie"/>
                  </div>
              </div>
            </div>}

            {menu == 'Overall' &&
            <>
            <div className='mt-2 md:flex '>
              <div className='border md:w-[35%] mr-2 md:h-[230px]'>
                  <div className='mt-2 px-2'>
                    <h1 className='font-bold pl-2 text-[14px]'>Analytics / <span className='text-[12px] text-gray-400 font-[500]'> Total Client v/s Subscribed Client</span> </h1>
                    <ReactApexChart width={370} options={chartOptions} size={'10'} series={[data?.total_client,data?.subscribed_client]} type="pie"/>
                  </div>
              </div>

              <div className='border mt-2 md:mt-0 md:w-[65%] md:h-[230px]'>
                <div className='mt-2 px-2'>
                    <h1 className='font-bold pl-2 text-[14px]'>Client Analytics</h1>
                    <ReactApexChart options={chartOptions1} size={'10'} series={chartOptions1.series} type="bar" width={'100%'} height={240} />
                </div>    
              </div>
            </div>

            <div className='mt-10 px-2 border'>
                <h1 className='font-bold pl-2 pt-2 text-[14px]'>Standard Analytics</h1>
                <ReactApexChart options={chartOptions2} size={'10'} series={chartOptions2.series} type="bar" width={'100%'} height={240} />
            </div>
            </>}
            </>}
            </>}
          </div>}
        </div> 

        
      </div>
    </div>
    
  )
}

export default Dashboard